<template>
    <div>
        <b-modal
            :visible="value"
            :id="modal_id"
            size="xl"
            @cancel="cancel"
            @close="cancel"
            @hidden="hidden"
        >
            <template #modal-title>
                Preview Article
            </template>
            <div v-if="loading_article_data" class="mb-3">
                <b-spinner label="Loading..."></b-spinner>
            </div>
            <ArticlePreview v-else
                @updatedExpiration="updatedExpiration"
                @updateSearch="updateSearch"
                :article="article_data"
                :vocabulary_terms="vocabulary_terms"
                :pedigree_chart="pedigree_chart"
                :walkthrough_media="walkthrough_media"
                :rubric_table_data="rubric_table_data"
                :rubric_type="rubric_type"
            ></ArticlePreview>

            <template #modal-footer>
                <b-button
                    variant="light"
                    @click="cancel"
                >
                    Close
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>

import Article from '@/components/article/Index'
import ArticlePreview from '@/components/article/ArticlePreview'

export default {
    data: () => ({
        article_data: null,
        loading_article_data: false,
        walkthrough_media_loading: false,
        walkthrough_media: [],
        rubric_table_data: [],
        rubric_type: null,
        vocabulary_terms: [],
        pedigree_chart: []
    }),
    props: [
        'value',
        'unit_group',
        'unit',
        'article',
        'article_id'
    ],
    components: {
        Article,
        ArticlePreview
    },
    computed: {
        modal_id () {
            let modal_id = 'article_modal'
            return modal_id
        },
    },
    watch: {
        value: {
            handler (value) {
                if (value == true) {
                    this.getArticle()
                    this.getVocabularyTerms()
                    this.getWalkthroughMedia()
                    this.getRubric()
                }
            }
        }
    },
    methods: {
        getArticle() {
            this.loading_article_data = true
            this.$store.dispatch('getArticles', this.article_id)
            .then(response => {
                this.article_data = response.data[0]
                this.pedigree_chart = _.orderBy(this.article_data.units, ['publication.id', 'order_number'])
                this.loading_article_data = false
            })
        },
        getVocabularyTerms () {

            this.axios.get('/api/articles/vocabulary/' + this.article_id)
            .then(response => {
                if (response.data) {
                    this.vocabulary_terms = _.orderBy(response.data, 'term')
                }
            })
        },
        async getWalkthroughMedia() {
            this.walkthrough_media_loading = true
            try {
                await this.$store.dispatch('getWalkthroughSlides', this.article_id)
                this.walkthrough_media = this.$store.state.walkthrough.slides[this.article_id]
            } catch (e) {

            } finally {
                this.walkthrough_media_loading = false
            }
        },
        getRubric(){
            this.axios.get('/api/articles/rubric/' + this.article_id)
            .then(response => {
                if(response.data && response.data.id){
                    this.rubric_table_data = response.data.rubric_data;
                    this.rubric_type = response.data.type == 'single' ? 'Single Point Rubric' : 'Multi-Point Rubric';
                }
            })
            .catch(error => {
                if (error) {
                    console.log(error)
                }
            })
        },
        cancel (event) {
            event.preventDefault()
                this.hide()
        },
        hide () {
            this.$emit('hide')
        },
        hidden () {
            this.$emit('hide')
        },
        updatedExpiration(){
            this.$emit('updatedExpiration');
        },
        updateSearch(){
            this.$emit('updateSearch');
        }
    }
}
</script>
